import * as React from "react";
import {Button, Popup} from "semantic-ui-react";
import {Icon} from "../../../../../../core/components/icon/icon";

interface UpdateButtonProps {
    active: boolean;
    onUpdate?: (e: React.MouseEvent) => void;
}
export const UpdateButton = ({active, onUpdate}: UpdateButtonProps) => (
    <>
        <Popup content="Feature auswählen und anpassen"
            trigger={
                <Button className={"feature-update-selection"} circular size="mini"
                    active={active}
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onUpdate) { onUpdate(e); }
                    }}>
                    <Icon name={"mouse_pointer"} />
                </Button>
            } />
    </>
);
interface CancelButtonProps {
    onCancel?: (e: React.MouseEvent) => void;
}
export const CancelButton = ({onCancel}: CancelButtonProps) => (
    <>
        <Popup content="Abbrechen"
            trigger={
                <Button className={"cancel-feature-construction"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onCancel) { onCancel(e); }
                    }}>
                    <Icon name={"navigate_cross"} />
                </Button>
            } />
    </>
);

interface SaveButtonProps {
    onSave?: (e: React.MouseEvent) => void;
}
export const SaveButton = ({onSave}: SaveButtonProps) => (
    <>
        <Popup content="Speichern"
            trigger={
                <Button className={"save-feature-construction"} primary size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onSave) { onSave(e); }
                    }}>
                    <Icon name={"floppy_disk"} />
                       Speichern
                </Button>
            } />
    </>
);

interface SaveUpdatesButtonProps {
    onSave?: (e: React.MouseEvent) => void;
}
export const SaveUpdatesButton = ({onSave}: SaveUpdatesButtonProps) => (
    <>
        <Popup content="Änderungen Speichern"
            trigger={
                <Button className={"save-update-feature-construction"} primary size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onSave) { onSave(e); }
                    }}>
                    <Icon name={"save_as"} />
                       Speichern
                </Button>
            } />
    </>
);

interface DeleteButtonProps {
    onDelete?: (e: React.MouseEvent) => void;
}
export const DeleteButton = ({onDelete}: DeleteButtonProps) => (
    <>
        <Popup content="Löschen"
            trigger={
                <Button className={"delete-feature"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onDelete) { onDelete(e); }
                    }}>
                    <Icon name={"garbage_can"} />
                </Button>
            } />
    </>
);

interface UndoButtonProps {
    onUndo?: (e: React.MouseEvent) => void;
}
export const UndoButton = ({onUndo}: UndoButtonProps) => (
    <>
        <Popup content="Änderung rückgängig machen"
            trigger={
                <Button className={"undo-feature-update"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onUndo) { onUndo(e); }
                    }}>
                    <Icon name={"undo"} />
                </Button>
            } />
    </>
);

interface RedoButtonProps {
    onRedo?: (e: React.MouseEvent) => void;
}
export const RedoButton = ({onRedo}: RedoButtonProps) => (
    <>
        <Popup content="Änderung erneut anwenden"
            trigger={
                <Button className={"redo-feature-update"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onRedo) { onRedo(e); }
                    }}>
                    <Icon name={"redo"} />
                </Button>
            } />
    </>
);
